import {
	linkScroll,
	animate,
	mobileMenu,
	formValidation,
	header,
	credit,
	initAccordions,
	initSliders,
	initModals,
} from './utils/helpers';

// Load classes
require('./components/carousel');
require('./components/map');
require('./components/animations');

// Load event helpers on DOM load
document.addEventListener('DOMContentLoaded', () => {
	linkScroll();
	animate();
	mobileMenu();
	formValidation();
	initAccordions();
	initSliders();
	initModals();
	header();
	credit();

	// === GSAP SplitText reveal (vertical) ===
	/* global gsap, ScrollTrigger, SplitText */
	try {
	if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && typeof SplitText !== 'undefined') {
		// Register plugins (no-op if already registered)
		gsap.registerPlugin(ScrollTrigger, SplitText);

		// Helper to convert viewport height percentage to pixels
		const vh = (v) => (window.innerHeight || document.documentElement.clientHeight) * (v / 100);

		// ScrollTrigger for .reveal-type-vertical
		document.querySelectorAll('.reveal-type-vertical').forEach((element) => {
		const splitText = new SplitText(element, { type: 'lines' });

		gsap.from(splitText.lines, {
			scrollTrigger: {
			trigger: element,
			// mirrors original `vh(-30) + ' center'`
			start: () => `top+=${vh(-30)} center`,
			end: 'bottom 100px',
			},
			opacity: 0,
			y: 80,
			stagger: 0.1,
			duration: 1.1,
			ease: 'power2.out',
		});
		});

		  // --- .reveal-type-block p (scrub in) ---
		if (document.querySelector('.reveal-type-block p')) {
			const items = gsap.utils.toArray('.reveal-type-block p');
			gsap.set(items, { y: 30, opacity: 0 });
			items.forEach((item) => {
			gsap.to(item, {
				y: 0,
				opacity: 1,
				ease: 'power3.out',
				scrollTrigger: {
				trigger: item,
				end: 'center center',
				scrub: true,
				delay: 1.3,
				// note: stagger doesn’t apply to a single target; handled by per-item loop
				},
			});
			});
		}

		// --- .reveal-type-hero-block p (simple timed fade/slide) ---
		if (document.querySelector('.reveal-type-hero-block p')) {
			const items = gsap.utils.toArray('.reveal-type-hero-block p');
			gsap.set(items, { y: 30, opacity: 0 });
			items.forEach((item) => {
			gsap.to(item, {
				y: 0,
				opacity: 1,
				ease: 'power3.out',
				duration: 1,
				delay: 0.2,
				// stagger handled by forEach timing in practice; keep simple per-item
			});
			});
		}

		// --- Hero heading SplitText reveal ---
		const headerTargets = document.querySelectorAll('.header-type-anim');
		if (headerTargets.length) {
			headerTargets.forEach((el) => el.classList.add('active'));
			const headerSplitText = new SplitText('.header-type-anim', { type: 'lines' });
			gsap.delayedCall(0.4, () => {
			gsap.to(headerSplitText.lines, {
				opacity: 1,
				y: 0,
				duration: 1.2,
				ease: 'power2.out',
				stagger: 0.08,
			});
			});
		}

		// --- .scrub-up (fade/slide up with scrub) ---
		if (document.querySelector('.scrub-up')) {
			const items = gsap.utils.toArray('.scrub-up');
			gsap.set(items, { y: -50, opacity: 0 });
			items.forEach((item) => {
			gsap.to(item, {
				y: 0,
				opacity: 1,
				ease: 'power3.out',
				scrollTrigger: {
				trigger: item,
				end: 'center center',
				scrub: true,
				},
			});
			});
		}

		// Batch fade-up for grid items
		if (document.querySelector('.grid__entry')) {
			ScrollTrigger.batch('.grid__entry', {
				interval: 0.1,
				batchMax: 8,
				trigger: '.grid',
				start: 'top 85%',
				once: true,
				onEnter: (batch) =>
					gsap.fromTo(
						batch,
						{ y: 30, opacity: 0 },
						{
							y: 0,
							opacity: 1,
							duration: 0.9,
							ease: 'power2.out',
							stagger: { each: 0.08, from: 'start' },
							overwrite: 'auto',
						}
					),
			});
		}

		if (document.querySelector('.inline-logos__entry')) {
			ScrollTrigger.batch('.inline-logos__entry', {
				interval: 0.1,
				batchMax: 8,
				trigger: '.inline-logos',
				start: 'top 85%',
				once: true,
				onEnter: (batch) =>
					gsap.fromTo(
						batch,
						{ y: 30, opacity: 0 },
						{
							y: 0,
							opacity: 1,
							duration: 0.9,
							ease: 'power2.out',
							stagger: { each: 0.08, from: 'start' },
							overwrite: 'auto',
						}
					),
			});
		}

		if (document.querySelector('.blocks__entry')) {
			ScrollTrigger.batch('.blocks__entry', {
				interval: 0.1,
				batchMax: 8,
				trigger: '.blocks',
				start: 'top 85%',
				once: true,
				onEnter: (batch) =>
					gsap.fromTo(
						batch,
						{ y: 30, opacity: 0 },
						{
							y: 0,
							opacity: 1,
							duration: 0.9,
							ease: 'power2.out',
							stagger: { each: 0.08, from: 'start' },
							overwrite: 'auto',
						}
					),
			});
		}

		// Item Scale In without scroll trigger
		if (document.querySelector('.scrub-up-initial')) {
			const scrubUpInitial = gsap.utils.toArray('.scrub-up-initial');
			scrubUpInitial.forEach(item => {
				gsap.to(item, {
					y: 0,
					opacity: 1,
					ease: Power3.easeOut,
					delay: 0.5,
					duration: 1.5,
					ease: "power2.out",
					stagger: 1,
				})
			});
		}

		// --- .scale-in (scale + slide with scrub) ---
		if (document.querySelector('.scale-in')) {
			const items = gsap.utils.toArray('.scale-in');
			gsap.set(items, { scale: 0.94, y: 50, opacity: 1 });
			items.forEach((item) => {
			gsap.to(item, {
				y: 0,
				scale: 1,
				opacity: 1,
				ease: 'power3.out',
				scrollTrigger: {
				trigger: item,
				end: 'center center',
				scrub: true,
				delay: 1,
				},
			});
			});
		}
	} else {
		console.warn('[GSAP] gsap/ScrollTrigger/SplitText not found. Ensure they are enqueued globally before this bundle.');
	}
	} catch (e) {
	console.error('Error initialising GSAP SplitText reveal:', e);
	}
});
